import { observer } from 'mobx-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { currentUserStore } from '../../CurrentUserStore';
import ErrorLanding from '../../ErrorLanding';
import HomePage from '../../HomePage';
import { findLink } from '../../LinkyLinky';
import Logout from '../../Logout';
import Communications from '../LearningCollections/Communications';
import Dashboard from '../LearningCollections/Dashboard';
import ChatbotPreview from '../LearningCollections/LearningCollection/ChatbotPreview';
import BuilderV2Edit from '../LearningCollections/LearningCollection/CurrentCollectionStep/BuilderV2/Edit';
import BuilderV2 from '../LearningCollections/LearningCollection/CurrentCollectionStep/BuilderV2/New';
import Preview from '../LearningCollections/LearningCollection/Preview';
import Share from '../LearningCollections/LearningCollection/Share';
import NotFound from '../NotFound';
import People from '../People';
import Group from '../People/Group';
import Groups from '../People/Groups';
import EditGroupPage from '../People/Groups/EditGroupPage';
import NewGroupPage from '../People/Groups/NewGroupPage';
import ImportParticipants from '../People/ImportParticipants';
import ImportParticipantsV2 from '../People/ImportParticipantsV2';
import Participants from '../People/Participants';
import AddParticipant from '../People/Participants/AddParticipant';
import PeopleV2 from '../PeopleV2';
import PeopleV2Groups from '../PeopleV2/Groups';
import PeopleV2Participants from '../PeopleV2/Participants';
import Products from '../Products';
import ProductLicenses from '../Products/ProductLicenses';
import Report from '../Report';
import Reports from '../Reports';
import SingleSignOn from '../SingleSignOn';
import AddConnection from '../SingleSignOn/AddConnection';
import Connection from '../SingleSignOn/Connection';

function PlatformRouter() {
  return (
    <Routes>
      {findLink('tasks', currentUserStore.links)
        .map(() => <Route path="/" element={<Navigate to="/home" />} />)
        .orElse(() =>
          findLink('learning-collections', currentUserStore.links).map(() => (
            <Route path="/" element={<Navigate to="/learning_collections" />} />
          )),
        )
        .orElse(() =>
          findLink('reports', currentUserStore.links).map(() => (
            <Route path="/" element={<Navigate to="/reports" />} />
          )),
        )
        .getOrElse(() => (
          <Route path="/" element={<ErrorLanding />} />
        ))}
      <Route path="/learning_collections/:id/preview" element={<Preview />} />
      {findLink('new-learning-collection-template-v2', currentUserStore.links)
        .map(() => <Route path="/learning_collections/builder_v2" element={<BuilderV2 />} />)
        .getOrElse(() => (
          <Route path="/learning_collections/builder_v2" element={<NotFound />} />
        ))}
      {findLink('edit-learning-collection-template-v2', currentUserStore.links)
        .map(() => (
          <Route path="/learning_collections/builder_v2/:id" element={<BuilderV2Edit />} />
        ))
        .getOrElse(() => (
          <Route path="/learning_collections/builder_v2/:id" element={<NotFound />} />
        ))}
      {findLink('communication-overrides-index', currentUserStore.links)
        .map(() => (
          <Route path="/learning_collections/:id/communications" element={<Communications />} />
        ))
        .getOrElse(() => (
          <Route path="/learning_collections/:id/communications" element={<NotFound />} />
        ))}
      <Route path="/learning_collections/*" element={<Dashboard />} />
      <Route path="/learning_collections/chatbot_preview" element={<ChatbotPreview />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/reports/:id" element={<Report />} />
      <Route path="/home" element={<HomePage />} />
      {findLink('people-v2', currentUserStore.links)
        .map(() => (
          <Route path="people" element={<PeopleV2 />}>
            <Route index element={<Navigate to="participants" />} />
            <Route path="participants" element={<PeopleV2Participants />} />
            {findLink('user-groups', currentUserStore.links)
              .map(() => <Route path="groups" element={<PeopleV2Groups />} />)
              .getOrElse(() => (
                <></>
              ))}
            <Route path="/people/groups/:id" element={<Group />} />
          </Route>
        ))
        .getOrElse(() => (
          <Route path="people" element={<People />}>
            <Route index element={<Navigate to="participants" />} />
            <Route path="participants" element={<Participants />} />
            {findLink('user-groups', currentUserStore.links)
              .map(() => <Route path="groups" element={<Groups />} />)
              .getOrElse(() => (
                <></>
              ))}
            <Route path="/people/groups/:id" element={<Group />} />
          </Route>
        ))}
      <Route path="/people/groups/new" element={<NewGroupPage />} />
      <Route path="/people/groups/:id/edit" element={<EditGroupPage />} />
      {findLink('products', currentUserStore.links)
        .map((link) => (
          <Route path="products" element={<Products />}>
            <Route index element={<Navigate to="product_licenses" />} />
            <Route path="product_licenses" element={<ProductLicenses productsLink={link} />} />
          </Route>
        ))
        .getOrElse(() => (
          <></>
        ))}
      <Route path="/people/add_participant" element={<AddParticipant />} />
      {findLink('import-multiple-participants', currentUserStore.links)
        .map(() => <Route path="/people/import_participants" element={<ImportParticipantsV2 />} />)
        .orElse(() =>
          findLink('import-participants', currentUserStore.links).map(() => (
            <Route path="/people/import_participants" element={<ImportParticipants />} />
          )),
        )
        .getOrElse(() => (
          <></>
        ))}
      <Route path="/learning_collections/:id/share" element={<Share />} />
      {findLink('sso-configurations', currentUserStore.links)
        .map(() => (
          <>
            <Route path="/single_sign_on" element={<SingleSignOn />} />
            <Route path="/single_sign_on/add" element={<AddConnection />} />
            <Route path="/single_sign_on/connections/:id" element={<Connection />} />
          </>
        ))
        .getOrElse(() => (
          <></>
        ))}
      <Route path="/logout" element={<Logout />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default observer(PlatformRouter);
